import { Public_Routes } from '@common/url';
import { historyReplace, navigateAndRefresh } from '@prophecy/utils/history';

export const redirectToAuth = (softRedirect = false, redirectUrl = window.location.href) => {
  if (softRedirect) {
    historyReplace(Public_Routes.SignIn.getUrl(undefined, { redirect: redirectUrl }));
  } else {
    navigateAndRefresh(Public_Routes.SignIn.getUrl(undefined, { redirect: redirectUrl }));
  }
};
